import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UNITS } from "@/data/workbook";
import CameraCaptureButton from "@/components/CameraCaptureButton";

export default function MeasurementsBlock({ block, value = {}, onChange, onCapture }) {
  const set = (rowK, patch) => onChange({ ...value, [rowK]: { ...(value[rowK] || {}), ...patch } });
  return (
    <div className="overflow-hidden rounded-xl border border-border bg-card/60 print-avoid-break">
      {block.title && <div className="border-b border-border px-4 py-3 text-sm font-semibold uppercase tracking-wider">{block.title}</div>}
      <div className="divide-y divide-border">
        {block.rows.map((r) => {
          const v = value[r.k] || {};
          const isText = r.unit === "";
          return (
            <div key={r.k} className="flex flex-col gap-2 px-4 py-3 sm:flex-row sm:items-center">
              <div className="flex-1 text-sm text-foreground">{r.label}</div>
              <div className="flex items-center gap-2">
                <Input
                  data-testid={`meas-${block.key}-${r.k}-value`}
                  value={v.value || ""}
                  onChange={(e) => set(r.k, { value: e.target.value })}
                  placeholder="Value"
                  className={`w-full sm:w-36 bg-secondary/40 ${isText ? "" : "font-mono"}`}
                />
                {!isText && (
                  <Select value={v.unit || r.unit} onValueChange={(u) => set(r.k, { unit: u })}>
                    <SelectTrigger data-testid={`meas-${block.key}-${r.k}-unit`} className="w-24 bg-secondary/40 font-mono text-xs">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {UNITS.map((u) => <SelectItem key={u} value={u} className="font-mono">{u}</SelectItem>)}
                    </SelectContent>
                  </Select>
                )}
                <Input
                  data-testid={`meas-${block.key}-${r.k}-photo`}
                  value={v.photo || ""}
                  onChange={(e) => set(r.k, { photo: e.target.value })}
                  placeholder="PH-###"
                  className="w-24 bg-secondary/40 font-mono text-xs"
                />
                {onCapture && (
                  <CameraCaptureButton
                    testid={`meas-cam-${block.key}-${r.k}`}
                    onCapture={async (file) => {
                      const rec = await onCapture(file, { area: r.label });
                      if (rec?.photo_id) set(r.k, { photo: rec.photo_id });
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
